import React, { cloneElement } from 'react';
import { Modal } from '@anyemp/ui-kit';
import useModalStackRegistration from '../../hooks/useModalStackRegistration';

/**
 * Compatibility adapter for legacy Talent modal call sites.
 * UI Kit owns the portal, backdrop, focus trap and base scroll locking.
 */
const ModalPortal = ({
  onClose,
  children,
  initialFocusRef,
}) => {
  const isTopmost = useModalStackRegistration(true);

  const child = React.Children.only(children);
  const interactiveChild = cloneElement(child, {
    style: {
      ...child.props.style,
      pointerEvents: 'auto',
    },
  });

  return (
    <Modal
      open
      onClose={onClose}
      closeOnBackdropClick={Boolean(onClose) && isTopmost}
      closeOnEscape={Boolean(onClose) && isTopmost}
      showCloseButton={false}
      initialFocusRef={initialFocusRef}
      size="medium"
      style={{
        width: '100%',
        maxWidth: 'none',
        maxHeight: 'none',
        padding: 0,
        overflow: 'visible',
        display: 'flex',
        justifyContent: 'center',
        background: 'transparent',
        borderRadius: 0,
        boxShadow: 'none',
        pointerEvents: 'none',
      }}
      backdropStyle={{
        padding: '0.75rem',
        overflowY: 'auto',
      }}
    >
      {interactiveChild}
    </Modal>
  );
};

export default ModalPortal;
